// import VueRouter, { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')

export default [
  {
    path: '/plan',
    name: 'plan',
    component: Layout,
    meta: {
      title: '体育教学规划',
      icon: 'el-icon-date',
    },
  },
]
